import useEventListElement from '../../../hooks/adminEvents/useEventListElement';

const EventList = () => useEventListElement();

export default EventList;
